import { render, staticRenderFns } from "./InsurancesPlanDetailsEdit.vue?vue&type=template&id=11bdc610&scoped=true&"
import script from "./InsurancesPlanDetailsEdit.vue?vue&type=script&lang=js&"
export * from "./InsurancesPlanDetailsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11bdc610",
  null
  
)

export default component.exports